import React, { useEffect, useState } from 'react';
import {
    Dropdown,
    Button,
    Icon,
    Form,
    Grid,
    Segment,
    Header,
    Divider,
    Card,
    Popup,
    Message,
    Radio,
} from 'semantic-ui-react';
import ClientRepository from '../../../common/repository/ClientRepository';
import Result from '../../../common/repository/Result';
import { toast } from '../../common/Toast';
import FormLabel from '../../common/FormLabel';
import { Table,  Modal } from 'semantic-ui-react'
import config from '../../../common/repository/config';
import LocalStorage from '../../../lib/LocalStorage';
import constants from '../../../common/constants';
import FileLabel from '../../common/FileLabel';

const AddFeedbackPrompt: React.FC = () => {
    const [feedbackType, setFeedbackType] = useState<any[]>([]);
    const [selectedFeedbackType, setSelectedFeedbackType] = useState<string>('');
    const [files, setFiles] = useState<FileList | null>(null);
    const [uploading, setUploading] = useState<boolean>(false);
    const [promptList, setPromptList] = useState<any[]>([]);
    const [loadingList, setLoadingList] = useState<boolean>(false);
    const [editOpen, setEditOpen] = useState<boolean>(false);
    const [editItem, setEditItem] = useState<any>(null);
    useEffect(() => {
        const options = Object.entries(constants.feedback).map(
            ([key, value]) => ({
                key,
                value: value,
                text: value,
            })
        );
        setFeedbackType(options);
        getFeedbackPrompts();
    }, []);
    const handleSubmit = async () => {
        if (!selectedFeedbackType) {
            toast.error('Please select feedback analysis type');
            return;
        }

        if (!files || files.length === 0) {
            toast.error('Please select a analysis prompt file');
            return;
        }

        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

        if (!token) {
            toast.error('Auth token missing');
            return;
        }

        try {
            setUploading(true);

            const formData = new FormData();

            formData.append('feedbackPrompt', files[0]);
            formData.append('feedbackType', selectedFeedbackType);
            const response = await fetch(`${config.apiBaseURL}/client/add/feedbackAnalysisPrompt`, {
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                body: formData
                
            });
    
            const result = await response.json();
    
            if (!response.ok) {
                toast.error(result?.message || 'Upload failed');
                return;
            }
            console.log(result,"analyssis");
            if (result.success) {
                toast.success(result.message || 'Feedback prompt uploaded successfully');
                setSelectedFeedbackType('');
                setFiles(null);
            } else {
                toast.error(result.message || 'Unable to upload feedback prompt');
            }

        } catch (e) {
            toast.error(
                (e as Error)?.message|| 'Something went wrong while uploading feedback prompt'
            );
        } finally {
            setUploading(false);
        }
    };
    const getFeedbackPrompts = async () => {
        try {
            setLoadingList(true);

            const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

            const response = await fetch(
                `${config.apiBaseURL}/client/list/feedbackAnalysisPrompt`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token || '',
                    },
                    body: JSON.stringify({
                        offset: 0,
                        limit: 100,
                    }),
                }
            );

            const result = await response.json();

            if (result.success) {
                setPromptList(result.data.items || []);
            }

        } catch (e) {
            toast.error('Unable to fetch feedback prompts');
        } finally {
            setLoadingList(false);
        }
    };
    const openEdit = async(item: any) => {
        setEditItem(item);
        setSelectedFeedbackType(item.feedback_type);
        setEditOpen(true);
    }
    const handleUpdate = async () => {
        if (!selectedFeedbackType) {
            toast.error('Please select feedback analysis type');
            return;
        }

        const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

        if (!token) {
            toast.error('Auth token missing');
            return;
        }

        try {
            setUploading(true);

            const formData = new FormData();
            if (files !== null && files.length > 0) {
                formData.append('feedbackPrompt', files[0]);
            }
            
            formData.append('feedbackType', selectedFeedbackType);
            formData.append('feedbackAnalysisPromptId', editItem._id);
            const response = await fetch(`${config.apiBaseURL}/client/update/feedbackAnalysisPrompt`, {
                method: 'POST',
                headers: {
                    'x-access-token': token,
                },
                body: formData
                
            });
    
            const result = await response.json();
    
            if (!response.ok) {
                toast.error(result?.message || 'Upload failed');
                return;
            }

            if (result.success) {
                toast.success(result.message || 'Feedback prompt uploaded successfully');
                setEditOpen(false);
                setSelectedFeedbackType('');
                setFiles(null);
            } else {
                toast.error(result.message || 'Unable to upload feedback prompt');
            }

        } catch (e) {
            toast.error(
                (e as Error)?.message|| 'Something went wrong while uploading feedback prompt'
            );
        } finally {
            setUploading(false);
        }        
    }
    return (
        <>
            <Segment padded="very">
                <Header as="h3" textAlign="center" style={{ marginBottom: '30px' }}>
                    <Icon name="file alternate outline" />
                    <Header.Content>Add Feedback Analysis Prompt</Header.Content>
                </Header>
                <Divider />
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={10}>
                        <Form>
                            <Form.Group inline>
                                <Form.Field>
                                    <FormLabel width="200px">Select Feedback Analysis Type</FormLabel>
                                <Dropdown
                                    key={selectedFeedbackType}
                                    search
                                    selection
                                    placeholder="Feedback Analysis Type"
                                    options={feedbackType}
                                    value={selectedFeedbackType}
                                    onChange={(e, data) => setSelectedFeedbackType(data.value as string)}
                                />
                                </Form.Field>
                                <Form.Field>
                                    <FormLabel width="200px">Upload File</FormLabel>
                                    <input
                                        type="file"
                                        onChange={(e) => setFiles(e.target.files)}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <FormLabel width="200px"></FormLabel>
                                    <Button
                                        primary
                                        icon
                                        labelPosition="right"
                                        onClick={handleSubmit}
                                        loading={uploading}
                                        disabled={uploading || !files || files.length === 0}
                                    >
                                        <Icon name="upload" />
                                        Upload
                                    </Button>
                                </Form.Field>
                            </Form.Group>
                        </Form>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Segment>
            {
                promptList.length > 0 && (
                    <Segment padded="very">
                        <Header as="h3">
                            <Icon name="list alternate outline" />
                            <Header.Content>
                                Added Feedback Analysis Prompts
                            </Header.Content>
                        </Header> 
                        <Divider />  
                        <Table celled striped compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Type</Table.HeaderCell>
                                    <Table.HeaderCell>Analysis Prompt</Table.HeaderCell>
                                     <Table.HeaderCell>Action</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {promptList.map((item, index) => 
                                    <Table.Row key={item._id}>
                                        <Table.Cell>{item.feedback_type}</Table.Cell>
                                        <Table.Cell>
                                            <FileLabel
                                            title={item.feedback_prompt.split("/").pop()}
                                            link={`${config.frontEndURL}/${item.feedback_prompt}`}
                                            />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Button size="small" onClick={() => openEdit(item)} icon labelPosition="left">
                                                <Icon name="edit" /> Edit
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>                      
                                )}
                            </Table.Body>
                        </Table>              
                    </Segment>        
                )
            }
            <Modal open={editOpen} onClose={() => {
                setEditOpen(false);
            }} size="small" closeIcon>
                <Header icon="edit" content="Edit Prompt" />
                <Modal.Content>
                    <Form>
                        <Grid stackable columns={2} doubling>
                            <Grid.Column>
                                <Form.Field>
                                    <label><strong>FeedBack Type</strong></label>
                                    <Dropdown
                                        key={selectedFeedbackType}
                                        search
                                        selection
                                        placeholder="Feedback Analysis Type"
                                        options={feedbackType}
                                        value={selectedFeedbackType}
                                        onChange={(e, data) => setSelectedFeedbackType(data.value as string)}
                                    />
                                </Form.Field>
                            </Grid.Column>
                            <Grid.Column>
                                <Form.Field>
                                    <FormLabel width="200px">Upload File</FormLabel>
                                    <input
                                        type="file"
                                        onChange={(e) => setFiles(e.target.files)}
                                    />
                                </Form.Field>
                            </Grid.Column>
                        </Grid>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={() => {
                        setEditOpen(false);
                    }}>Cancel</Button>
                    <Button color="teal" onClick={handleUpdate}>
                        <Icon name="save" /> Update
                    </Button>
                </Modal.Actions>
            </Modal>            
        </>
    );
};

export default AddFeedbackPrompt;
